module.exports = __webpack_public_path__ + "static/img/摄图网_501125646_banner_在草地上玩耍的孩子们（非企业商用）@2x.5d3b596b.png";